import React from 'react'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import PerencanaanPegawai from 'app/KinerjaDinasPage/pages/PerencanaanPegawai'
import PageGuardDinas from 'app/KinerjaDinasPage/components/PageGuardDinas'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'

import type { KinerjaApp } from 'types/kinerja-layout'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled =
      (toggle?.['kinerja-dinas-enabled'] &&
        toggle?.['kinerja-dinas-perencanaan-enabled']) ||
      false

    if (!enabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }
  },
})

const Page: KinerjaApp = () => (
  <PageGuardDinas>
    <PerencanaanPegawai />
  </PageGuardDinas>
)

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
  centered: true,
  pageTitle: 'Perencanaan Kinerja Pegawai',
}

export default Page
